export default __webpack_public_path__ + "static/media/fa-solid-900.352ac9a0.svg";